import { PageInfo } from "src/app/shared/models/queryparams/pageinfo.model";
import { SortInfo } from "src/app/shared/models/queryparams/sortinfo.model";
export class CheckListGridParam {  
    productCategoryId : number = 0;
    pageInfo: PageInfo = new PageInfo();
    sortInfo: SortInfo = new SortInfo();
    searchText : string = '';
    manualSort: boolean = false;

}